import { Instagram, Mail, MapPin } from "lucide-react";
import { FOOTER } from "@/constants/testIds";

export default function Footer() {
  return (
    <footer
      data-testid={FOOTER.section}
      className="bg-[#03080F] border-t border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-14 grid md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-3">
            <img
              src="/brand/bba-logo.png"
              alt="Team BBA Elite"
              className="h-11 w-auto"
            />
            <div className="leading-tight">
              <div className="font-display text-base">BLEDSOE</div>
              <div className="text-[10px] tracking-[0.3em] text-[#A0ABC0]">
                BASKETBALL ACADEMY
              </div>
            </div>
          </div>
          <p className="text-[#A0ABC0] text-sm mt-5 max-w-sm">
            One of the finest basketball development programs in the
            Midwest. Founded by Sean Bledsoe — D1 Coach & Former NBA Player
            Consultant.
          </p>
        </div>

        <div>
          <div className="text-[11px] tracking-[0.25em] uppercase text-white/50 mb-4">
            Explore
          </div>
          <ul className="space-y-2 text-sm text-white/80">
            <li><a href="#about" className="hover:text-[#B8C5D6]">About</a></li>
            <li><a href="#programs" className="hover:text-[#B8C5D6]">Programs</a></li>
            <li><a href="#travel" className="hover:text-[#B8C5D6]">Travel Teams</a></li>
            <li><a href="#testimonials" className="hover:text-[#B8C5D6]">Voices</a></li>
            <li><a href="#contact" className="hover:text-[#B8C5D6]">Contact</a></li>
          </ul>
        </div>

        <div>
          <div className="text-[11px] tracking-[0.25em] uppercase text-white/50 mb-4">
            Contact
          </div>
          <ul className="space-y-3 text-sm">
            <li>
              <a
                href="mailto:bbatravelbasketball@gmail.com"
                data-testid={FOOTER.emailLink}
                className="inline-flex items-center gap-2 text-white/80 hover:text-[#B8C5D6]"
              >
                <Mail size={14} className="text-[#B8C5D6]" />
                bbatravelbasketball@gmail.com
              </a>
            </li>
            <li>
              <a
                href="https://www.instagram.com/bbatravelbasketball/"
                target="_blank"
                rel="noreferrer noopener"
                data-testid={FOOTER.instagramLink}
                className="inline-flex items-center gap-2 text-white/80 hover:text-[#B8C5D6]"
              >
                <Instagram size={14} className="text-[#B8C5D6]" />
                @bbatravelbasketball
              </a>
            </li>
            <li className="inline-flex items-center gap-2 text-white/80">
              <MapPin size={14} className="text-[#B8C5D6]" />
              Lees Summit, MO
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/45">
          <div>© {new Date().getFullYear()} Bledsoe Basketball Academy. All rights reserved.</div>
          <div className="tracking-[0.25em] uppercase">
            Maximize Strengths · Add Skill · Play The Right Way
          </div>
        </div>
      </div>
    </footer>
  );
}
